import jQuery from 'jquery';
import {
    pricesProvider,
    diffusionServiceUtils,
    pricesStateStore,
    PRICE_HANDLER_EVENTS } from 'rp-prices-component';

const HAS_PREVIOUS_PRICE_CLASS = 'RC-historyPrices__item_changed';
const HISTORY_PRICE_VALUE_CLASS = '.js-diffusionHistoryPriceValue';
const RUNNER_ROW_CLASS = '.js-RC-runnerRow';

function onPriceSettingsChanged({ showDecimal }) {
    jQuery('.js-diffusionHistoryPricesValues').toArray()
        .forEach((priceHistoryGroup) => {
            jQuery(priceHistoryGroup).find(HISTORY_PRICE_VALUE_CLASS).toArray()
                .forEach((priceValueElement, index) => {
                    const $priceValueElement = jQuery(priceValueElement);
                    const newViewValue = showDecimal
                        ? Math.floor(parseFloat($priceValueElement.attr(`data-history-price-decimal-${index}`)) * 100) / 100 || ''
                        : $priceValueElement.attr(`data-history-price-fractional-${index}`);

                    $priceValueElement.text(newViewValue);
                });
        });
}

function renderPrice(config) {
    const { historyPrices, showDecimalPrices, horseName, raceDate, raceTime, courseName } = config;
    const horse = diffusionServiceUtils
        .getPriceContainer({ horseName, raceDate, raceTime, courseName });
    const $runnerRow = jQuery(horse[0]).closest(RUNNER_ROW_CLASS);
    const prices = $runnerRow.find(HISTORY_PRICE_VALUE_CLASS).toArray();

    if (prices.length) {
        prices.forEach((value, index) => {
            const $priceValue = jQuery(value);

            $priceValue
                .text('')
                .removeClass(HAS_PREVIOUS_PRICE_CLASS)
                .attr(`data-history-price-fractional-${index}`, '')
                .attr(`data-history-price-decimal-${index}`, '');

            if (historyPrices.fractional[index] && historyPrices.decimal[index]) {
                const priceViewValue = showDecimalPrices
                    ? Math.floor(parseFloat(historyPrices.decimal[index]) * 100) / 100
                    : historyPrices.fractional[index];

                $priceValue
                    .text(priceViewValue)
                    .attr(`data-history-price-fractional-${index}`, historyPrices.fractional[index])
                    .attr(`data-history-price-decimal-${index}`, historyPrices.decimal[index]);

                if (historyPrices.decimal[index] !== historyPrices.decimal[index + 1]) {
                    $priceValue.addClass(HAS_PREVIOUS_PRICE_CLASS);
                }

                if (!!historyPrices.decimal[index] && !historyPrices.decimal[index + 1]) {
                    $priceValue.removeClass(HAS_PREVIOUS_PRICE_CLASS);
                }
            }
        });
    }
}

function onPriceReceived(renderConfig) {
    const showDecimalPrices = pricesStateStore.isDecimalPrice();

    renderPrice(Object.assign({}, renderConfig, { showDecimalPrices }));
}

function clearPrices() {
    jQuery(HISTORY_PRICE_VALUE_CLASS)
        .text('')
        .removeClass(HAS_PREVIOUS_PRICE_CLASS)
        .attr('data-history-price-decimal-0', '')
        .attr('data-history-price-decimal-1', '')
        .attr('data-history-price-decimal-2', '')
        .attr('data-history-price-decimal-3', '')
        .attr('data-history-price-fractional-0', '')
        .attr('data-history-price-fractional-1', '')
        .attr('data-history-price-fractional-2', '')
        .attr('data-history-price-fractional-3', '');
}

function onPricesWillBeUpdated() {
    clearPrices();
}

function activate() {
    pricesProvider.subscribe(PRICE_HANDLER_EVENTS.PRICE_RECEIVED,
        onPriceReceived);
    pricesProvider.subscribe(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED,
        onPriceSettingsChanged);
    pricesProvider.subscribe(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED,
        onPricesWillBeUpdated);
}

function deactivate() {
    pricesProvider.unsubscribe(PRICE_HANDLER_EVENTS.PRICE_RECEIVED,
        onPriceReceived);
    pricesProvider.unsubscribe(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED,
        onPriceSettingsChanged);
    pricesProvider.unsubscribe(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED,
        onPricesWillBeUpdated);
}

export const priceHistory = {
    activate,
    deactivate
};




// WEBPACK FOOTER //
// ./lib/js/modules/priceHistory.js